import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { message } from "antd"

import * as api from "../../../api"

import { useStateValue } from "../../_shared/context/AppStateStore"
import AppInput from "../../_shared/components/FormItems/AppInput"
import AppButton from "../../_shared/components/AppButton"

import CommandLine from "./CommandLine"

//------------------------------------------------------------------------------

function AuthPage(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [, dispatch] = useStateValue()

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleSignIn(event) {
    event.preventDefault()

    api
      .signIn(email, password)
      .then((res) => {
        dispatch({
          type: "SIGN_IN_FULFILLED",
          payload: res,
        })
      })
      .catch((error) => {
        if (error && error.statusCode === 401) {
          message.error("Le credenziali non sono corrette.")
        } else {
          const defaultMessage =
            "Non è stato possibile completare il login. Riprovare più tardi."

          const messageText = (error && error.serverMessage) || defaultMessage

          message.error(messageText)
        }
      })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <div className={props.className}>
      <div className="auth-container">
        <img
          className="logo"
          src={require("../../_shared/images/logo.png")}
          height={200}
        />
        <div className="form-container">
          <form onSubmit={handleSignIn}>
            <h2>Inserisci le credenziali</h2>

            <AppInput
              className="auth-input"
              placeholder="Email"
              value={email}
              onChange={setEmail}
              autocomplete={false}
            />

            <AppInput
              className={`password-input auth-input`}
              placeholder="Password"
              value={password}
              onChange={setPassword}
              hiddenText
              autocomplete={false}
            />

            <AppButton className="full-width">Sign In</AppButton>
          </form>
        </div>
      </div>

      <CommandLine />
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AuthPage.propTypes = {
  className: PropTypes.string.isRequired,
}

AuthPage.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAuthPage = styled(AuthPage)`
  & {
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-height: 100vh;

    min-width: 100vw;

    background-color: ${(props) => props.theme.colors.primaryBackgroundColor};

    .auth-container {
      position: relative;

      display: flex;
      flex-direction: column;
      align-items: center;

      margin-top: 10vh;

      width: 100%;
      height: 100%;

      overflow: hidden;

      .logo {
        margin-bottom: 60px;
      }

      .form-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        > form {
          display: flex;
          flex-direction: column;
          align-items: center;

          width: 300px;

          h2 {
            margin-bottom: 20px;
            color: ${(props) => props.theme.colors.textPrimaryColor};
            font-weight: 600;
          }

          .auth-input {
            margin-bottom: 25px;
          }

          .full-width {
            width: 100%;
          }
        }
      }
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledAuthPage
